import { PipelineRunRecord } from '../types';

/** Runs recorded before attribution tracking carry none of these, so their details drawer would be empty. */
export function isAttributionInfoAvailable(
  run: Pick<PipelineRunRecord, 'triggeredBy' | 'cancelledBy' | 'parentRunId' | 'rerunOfRunId'>
) {
  return Boolean(run.triggeredBy || run.cancelledBy || run.parentRunId || run.rerunOfRunId);
}
